/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { Icon } from 'semantic-ui-react';
import Chart from 'chart.js/auto';
import './ProjectSummaryView.css';

class SummaryView extends Component {
  constructor(props) {
    super(props);
    this.chart = null;
  }

  componentDidMount() {
    if (this.canvas) {
      this.drawChart();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.file.componentCount.total !== this.props.file.componentCount.total) {
      this.drawChart();
    }
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  abbreviateNumber(value) {
    let newValue = value;
    if (value >= 10000) {
      const suffixes = ['', 'K', 'M', 'B', 'T'];
      const suffixNum = Math.floor(` ${value}`.length / 4);
      let shortValue = '';
      let i = 4; //precision
      for (i; i >= 1; i--) {
        shortValue = parseFloat(
          (suffixNum !== 0 ? value / (1000 ** suffixNum) : value).toPrecision(i) // prettier-ignore
        ); // ** : Math.pow()
        const dotLessShortValue = `${shortValue} `.replace(/[^a-zA-Z 0-9]+/g, '');
        if (dotLessShortValue.length <= 4) {
          break;
        }
      }
      //if (shortValue % 1 !== 0) {
      //const shortNum = shortValue.toFixed(1);
      //console.log(shortNum);
      //}
      newValue = shortValue + suffixes[suffixNum];
    }
    return newValue;
  }

  drawChart() {
    const { translate } = this.props;
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }

    const config = {
      type: 'pie',
      data: {
        datasets: [
          {
            label: [translate('chart.title.total_lowercase'), translate('chart.title.risk')],
            data: [this.props.file.componentCount.has_risk, this.props.file.componentCount.total],
            backgroundColor: ['#FF7D00', '#ADA9B2'],
            borderWidth: 0,
            hoverOffset: 4,
          },
        ],
      },
      options: {
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        //responsive: true,
      },
    };

    const ctx = this.canvas.getContext('2d');
    this.chart = new Chart(ctx, config);
  }

  render() {
    const { translate } = this.props;
    return (
      <table className="summar_view summary_item_table small">
        <colgroup>
          <col width="8%" />
          <col width="20%" />
          <col width="20%" />
          <col width="20%" />
          <col width="16%" />
          <col width="16%" />
        </colgroup>
        <tbody>
          <tr>
            <td>
              <div className="summary_item">
                <p className="label">{translate('panel.menu.grade')}</p>
                <p className="value">{this.props.file.projectGrade}</p>
              </div>
            </td>
            <td>
              <div className="summary_item">
                <p className="label">{translate('panel.menu.component')}</p>
                <p className="value">
                  {this.abbreviateNumber(this.props.file.componentCount.total)}
                </p>
              </div>
              <div className="summary_chart pie">
                <span className="value">
                  {this.abbreviateNumber(this.props.file.componentCount.has_risk)}
                </span>
                <canvas
                  ref={(ref) => {
                    this.canvas = ref;
                  }}
                />
              </div>
            </td>
            <td>
              <div className="summary_item">
                <p className="label">{translate('panel.menu.security_risk')}</p>
                <p className="value">
                  {this.abbreviateNumber(this.props.file.securityCount.total)}
                  {this.props.file.hasExploit ? (<Icon name="bug" />) : null}
                </p>
              </div>
              <div className="summary_chart square_chart">
                <div>{this.abbreviateNumber(this.props.file.securityCount.critical)}</div>
                <div>{this.abbreviateNumber(this.props.file.securityCount.low)}</div>
                <div>{this.abbreviateNumber(this.props.file.securityCount.high)}</div>
                <div>{this.abbreviateNumber(this.props.file.securityCount.medium)}</div>
              </div>
            </td>
            <td>
              <div className="summary_item">
                <p className="label">{translate('panel.menu.license')}</p>
                <p className="value">{this.abbreviateNumber(this.props.file.licenseCount.total)}</p>
              </div>
              <div className="summary_chart bubble_chart">
                <div className="">
                  <div className="inner red">
                    {this.abbreviateNumber(this.props.file.licenseCount.protective)}
                  </div>
                </div>
                <div>
                  <div className="inner cheese">
                    {this.abbreviateNumber(this.props.file.licenseCount.permissive)}
                  </div>
                </div>
                <div>
                  <div className="inner yellow">
                    {this.abbreviateNumber(this.props.file.licenseCount.others)}
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div className="summary_item">
                <p className="label">{translate('panel.menu.litigator')}</p>
                <p className="value">{this.props.file.litigatorCount}</p>
              </div>
            </td>
            <td>
              <div className="summary_item">
                <p className="label">{translate('panel.menu.violated_policy')}</p>
                <p className="value">{this.props.file.policyCount}</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}
SummaryView.defaultProps = {
  file: {},
};

export default SummaryView;
